import { useState, useEffect } from 'react';
import { isTouchDevice } from '@srcDS/utils/assertions';

export const useTouchDevice = (isSSR: boolean) => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    if (!isSSR) {
      setIsTouch(isTouchDevice());
    }
  }, [isSSR]);

  return isTouch;
};